import { AppBar, Box, IconButton, SvgIcon, Toolbar, useTheme } from '@mui/material'
import { memo } from 'react'
import { IoMenu } from 'react-icons/io5'
import { Link as RouterLink } from 'react-router-dom'

import { Logo } from '@/components'

import AccountAvatar from './AcountAvatar'

function DashboardHeader(props: DashboardHeaderProps) {
  const { onMobileOpen } = props
  const theme = useTheme()

  return (
    <AppBar
      elevation={0}
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
        zIndex: theme.zIndex.drawer + 1,
      }}>
      <Toolbar sx={{ minHeight: 64, px: 3 }}>
        <IconButton
          sx={{
            mr: 2,
            display: { xs: 'flex', lg: 'none' },
            justifyContent: 'center',
            alignItems: 'center',
          }}
          color="inherit"
          onClick={onMobileOpen}>
          <SvgIcon fontSize="small">
            <IoMenu />
          </SvgIcon>
        </IconButton>

        <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
          <RouterLink
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}>
            <Logo colored={false} />
          </RouterLink>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <AccountAvatar />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

type DashboardHeaderProps = {
  onMobileOpen: () => void
}

export default memo(DashboardHeader)
